'use client';

import { useMutation } from '@tanstack/react-query';
import {
  startContentCreation,
  type StartContentCreationParams,
  type StartContentCreationResult,
} from '../actions/createContentPlan';
import type { ActionResult } from '@/shared/types/actions';

export function useStartContentCreation() {
  return useMutation<
    ActionResult<StartContentCreationResult>,
    Error,
    StartContentCreationParams
  >({
    mutationFn: (params) => startContentCreation(params),
  });
}
